import { Controller } from "@hotwired/stimulus";

// Uses the Web Share API when available; falls back to copying/opening the URL.
export default class extends Controller {
  static values = {
    url: String,
    title: String,
    text: String
  };

  share(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.hasUrlValue) return;

    const shareData = { url: this.urlValue };
    if (this.hasTitleValue) shareData.title = this.titleValue;
    if (this.hasTextValue) shareData.text = this.textValue;

    if (navigator.share) {
      navigator
        .share(shareData)
        .catch(() => {
          /* Ignore failures when the user dismisses the native share sheet */
        });
      return;
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.urlValue).catch(() => {
        window.open(this.urlValue, "_blank", "noopener");
      });
      return;
    }

    window.open(this.urlValue, "_blank", "noopener");
  }
}
